import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitButton', 'generateRadio', 'uploadRadio', 'certFileName', 'keyFileName'];
  static values = { canGenerate: Boolean, uploadFieldsUrl: String };

  connect() {
    this.confirmed = false;

    const form = this.element.querySelector('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        if (this.selectedMethod === 'generate' && !this.confirmed) {
          event.preventDefault();
          this.showGenerateConfirmation();
        }
      });
    }
  }

  selectMethod() {
    const selected = this.selectedMethod;

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !selected;
    }

    if (selected === 'upload') {
      this.loadUploadFields();
    } else {
      this.clearUploadFields();
    }
  }

  get selectedMethod() {
    if (this.hasGenerateRadioTarget && this.generateRadioTarget.checked) return 'generate';
    if (this.hasUploadRadioTarget && this.uploadRadioTarget.checked) return 'upload';
    return null;
  }

  loadUploadFields() {
    const frame = document.querySelector('turbo-frame#upload_fields');
    if (frame) {
      frame.src = this.uploadFieldsUrlValue;
    }
  }

  clearUploadFields() {
    const frame = document.querySelector('turbo-frame#upload_fields');
    if (frame) {
      frame.innerHTML = '';
      frame.removeAttribute('src');
    }
  }

  certFileSelected(event) {
    const file = event.target.files[0];
    if (this.hasCertFileNameTarget) {
      this.certFileNameTarget.textContent = file ? file.name : '';
    }
  }

  keyFileSelected(event) {
    const file = event.target.files[0];
    if (this.hasKeyFileNameTarget) {
      this.keyFileNameTarget.textContent = file ? file.name : '';
    }
  }

  showGenerateConfirmation() {
    const overlay = document.querySelector('.x-cert-confirm-overlay');
    const modal = document.querySelector('.x-cert-confirm-modal');
    if (!overlay || !modal) return;

    modal.querySelector('.x-cert-confirm-title').textContent = 'Generuj certyfikat offline';
    modal.querySelector('.x-cert-confirm-message').textContent =
      'Czy na pewno chcesz wygenerować certyfikat offline do Krajowego Systemu eFaktur?';

    const btn = modal.querySelector('.x-cert-confirm-btn');
    btn.textContent = 'Zapisz';
    btn.className = 'btn green btn--ok x-cert-confirm-btn';
    btn.onclick = () => {
      this.closeModal();
      this.confirmed = true;
      this.element.querySelector('form').requestSubmit();
    };

    overlay.style.display = '';
    modal.style.display = '';
    document.body.style.overflow = 'hidden';

    modal.querySelectorAll('.x-cert-confirm-close').forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();
        this.closeModal();
      };
    });
  }

  closeModal() {
    const overlay = document.querySelector('.x-cert-confirm-overlay');
    const modal = document.querySelector('.x-cert-confirm-modal');
    if (overlay) overlay.style.display = 'none';
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}
